import { IconMessageCircle, IconSearch, IconX } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { useIsMobile } from '../useIsMobile';
import { ChatPopover } from './ChatPopover';
import { GlobalSearch } from './GlobalSearch';
import { NotificationsPopover } from './NotificationsPopover';
import { ScopeSwitcher } from './ScopeSwitcher';
import { UserMenu } from './UserMenu';
import classes from './shell.module.css';

interface HeaderProps {
  searchOpen: boolean;
  onToggleSearch: () => void;
}

/** Black 56px top bar: logo → Home, scope, search, chat, notifications, account. */
export function Header({ searchOpen, onToggleSearch }: HeaderProps) {
  const isMobile = useIsMobile();

  return (
    <div className={classes.header}>
      <div className={classes.bar} data-mobile={isMobile || undefined}>
        <Link to="/" className={classes.logo} aria-label="Aroo home">
          <img src="/brand/aroo-logo.png" alt="Aroo" />
        </Link>
        <ScopeSwitcher />
        {!isMobile && <GlobalSearch variant="desktop" />}
        <span className={classes.spacer} />
        {isMobile && (
          <button
            type="button"
            className={classes.iconButton}
            data-open={searchOpen || undefined}
            aria-label={searchOpen ? 'Close search' : 'Search'}
            aria-expanded={searchOpen}
            onClick={onToggleSearch}
          >
            {searchOpen ? <IconX size={20} stroke={2} /> : <IconSearch size={20} stroke={2} />}
          </button>
        )}
        {!isMobile && (
          <ChatPopover
            position="bottom-end"
            target={({ opened, toggle, unread }) => (
              <button
                type="button"
                className={classes.iconButton}
                data-open={opened || undefined}
                aria-label={unread ? `Chat, ${unread} unread` : 'Chat'}
                aria-expanded={opened}
                onClick={toggle}
              >
                <IconMessageCircle size={20} stroke={2} />
                {unread > 0 && (
                  <span className={classes.badge} aria-hidden="true">
                    {unread > 99 ? '99+' : unread}
                  </span>
                )}
              </button>
            )}
          />
        )}
        <NotificationsPopover />
        <UserMenu />
      </div>
      {isMobile && searchOpen && (
        <div className={classes.mobileSearchRow}>
          <GlobalSearch variant="mobile" autoFocus onNavigate={onToggleSearch} />
        </div>
      )}
    </div>
  );
}
